import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sparkles, BookOpen, Code, FlaskConical, GraduationCap, Rocket, Briefcase, Maximize2 } from 'lucide-react';
import { QUICK_PROMPTS, CAPABILITIES } from './qoreAIConfig';

const ICONS = {
  book: BookOpen,
  code: Code,
  flask: FlaskConical,
  graduation: GraduationCap,
  rocket: Rocket,
  briefcase: Briefcase,
};

const QoreAIWelcome = ({ onPrompt, variant = 'widget', showExpandLink = false }) => {
  const { t } = useTranslation();
  const isPage = variant === 'page';

  return (
    <div className={`qai-welcome ${isPage ? 'qai-welcome--page' : 'qai-welcome--widget'}`}>
      <div className="qai-welcome__glow" aria-hidden />
      <div className="qai-welcome__icon" aria-hidden>
        <Sparkles size={isPage ? 36 : 28} strokeWidth={1.5} />
      </div>
      <h2 className="qai-welcome__title">{t('aiTutoring.welcomeTitle')}</h2>
      <p className="qai-welcome__desc">{t('aiTutoring.welcomeDesc')}</p>

      <div className="qai-capabilities" role="list">
        {CAPABILITIES.map((cap) => {
          const Icon = ICONS[cap.icon];
          return (
            <div key={cap.id} className="qai-capability" role="listitem">
              {Icon && <Icon size={16} strokeWidth={2} />}
              <span>{t(cap.labelKey)}</span>
            </div>
          );
        })}
      </div>

      <div className={`qai-prompts ${isPage ? 'qai-prompts--grid' : 'qai-prompts--stack'}`}>
        {QUICK_PROMPTS.map((q) => {
          const Icon = ICONS[q.icon];
          return (
            <button
              key={q.id}
              type="button"
              className="qai-prompt-btn"
              onClick={() => onPrompt(t(q.promptKey))}
            >
              {Icon && <span className="qai-prompt-btn__icon"><Icon size={17} /></span>}
              <span className="qai-prompt-btn__label">{t(q.labelKey)}</span>
            </button>
          );
        })}
      </div>

      {showExpandLink && (
        <Link to="/aitutoring" className="qai-expand-link">
          <Maximize2 size={14} />
          {t('aiTutoring.openFullPage')}
        </Link>
      )}
    </div>
  );
};

export default QoreAIWelcome;